import { render, staticRenderFns } from "./LegendImmokey.vue?vue&type=template&id=3a0b1a26&"
import script from "./LegendImmokey.vue?vue&type=script&lang=js&"
export * from "./LegendImmokey.vue?vue&type=script&lang=js&"
import style0 from "./LegendImmokey.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports